// Italian strings for WEDFLOW landing (i18n ready)
const it = {
  nav: {
    how: "Come funziona",
    benefits: "Perché WEDFLOW",
    pricing: "Prezzi",
    faq: "Domande",
    cta: "Crea il tuo matrimonio",
  },
  hero: {
    eyebrow: "Memorie di matrimonio · Piattaforma premium",
    headline_1: "Tutti i ricordi del",
    headline_2: "tuo matrimonio.",
    headline_3: "In un solo posto.",
    headline_4: "Entro domani.",
    sub: "WEDFLOW raccoglie ogni foto e video dei tuoi invitati tramite un semplice QR code e li trasforma in una galleria digitale elegante, pronta il giorno dopo le nozze.",
    cta_primary: "Crea il tuo matrimonio",
    cta_secondary: "Guarda come funziona",
    meta: "Nessuna app richiesta · QR code unico · Galleria privata",
  },
  how: {
    eyebrow: "Come funziona",
    title: "Tre passi. Zero stress.",
    sub: "Tutto pensato per te e per i tuoi invitati. Nessuna app da scaricare, nessuna complicazione.",
    steps: [
      {
        number: "01",
        title: "Stampa il tuo QR code",
        body: "Ricevi un QR code personalizzato da esporre al ricevimento, sui tavoli o sulle partecipazioni.",
      },
      {
        number: "02",
        title: "Gli invitati caricano",
        body: "Un tocco, la fotocamera si apre. Foto e video vengono salvati in tempo reale nel tuo spazio.",
      },
      {
        number: "03",
        title: "Galleria pronta domani",
        body: "Entro 24 ore ricevi una galleria digitale curata, privata e condivisibile con chi vuoi tu.",
      },
    ],
  },
  benefits: {
    eyebrow: "Perché WEDFLOW",
    title: "Il matrimonio resta. I ricordi anche.",
    items: [
      {
        title: "Niente più foto perse",
        body: "Tutti i momenti degli invitati in un'unica galleria. Mai più messaggi dispersi o chat di gruppo.",
      },
      {
        title: "Zero app da scaricare",
        body: "Un QR code. La fotocamera. Fatto. Funziona per chiunque, anche per i meno tecnologici.",
      },
      {
        title: "Privato e sicuro",
        body: "La tua galleria è protetta. Decidi tu chi può vedere, scaricare e rivivere ogni momento.",
      },
      {
        title: "Pronto il giorno dopo",
        body: "Una curatela automatica consegna i tuoi ricordi entro 24 ore dal sì.",
      },
      {
        title: "Qualità originale",
        body: "Foto e video salvati in alta risoluzione. Stampabili, condivisibili, per sempre.",
      },
      {
        title: "Design senza tempo",
        body: "Un'esperienza elegante, pensata per essere all'altezza del giorno più bello.",
      },
    ],
  },
  pricing: {
    eyebrow: "Prezzi",
    title: "Un piano per ogni matrimonio.",
    sub: "Nessun abbonamento. Paghi una volta, i ricordi restano per sempre.",
    plans: [
      {
        id: "free",
        name: "Free",
        price: "€0",
        period: "",
        description: "Per scoprire WEDFLOW prima del grande giorno.",
        features: [
          "1 QR code personale",
          "Fino a 20 foto (no video)",
          "Galleria attiva 15 giorni",
          "Download in risoluzione standard",
        ],
        cta: "Inizia gratis",
        highlighted: false,
      },
      {
        id: "smart",
        name: "Smart",
        price: "€59",
        period: "una tantum",
        description: "Tutto ciò che serve per raccogliere ogni ricordo del vostro giorno.",
        features: [
          "QR code illimitati",
          "Fino a 300 foto + video illimitati",
          "Galleria privata attiva 24 mesi",
          "Download in qualità originale",
          "Download ZIP della galleria completa",
        ],
        cta: "Scegli Smart",
        highlighted: false,
        badge: "Più scelto",
      },
      {
        id: "premium",
        name: "Premium",
        price: "€129",
        period: "una tantum",
        description: "L'esperienza completa. Ogni momento, ogni ospite, per sempre.",
        features: [
          "Tutto di Smart, incluso",
          "Foto e video illimitati",
          "Galleria privata attiva 36 mesi",
          "🎬 AI Wedding Reel generato automaticamente",
          "📺 Live Slideshow durante il ricevimento",
          "💌 Diario dei Ricordi con dediche degli ospiti",
          "Supporto prioritario dedicato",
        ],
        cta: "Scegli Premium",
        highlighted: true,
        badge: "Il più completo",
      },
    ],
  },
  testimonials: {
    eyebrow: "Cosa dicono gli sposi",
    title: "Parole vere, dal giorno più bello.",
    items: [
      {
        quote:
          "Non sapevo che i miei invitati avessero scattato così tante foto. Le ho scoperte la mattina dopo, una per una. Ho pianto.",
        author: "Martina",
        detail: "Sposa · Matrimonio a Firenze",
      },
      {
        quote:
          "Il QR code sul tavolo e in dieci minuti già arrivavano le prime foto. I miei suoceri che non usano WhatsApp ce l'hanno fatta benissimo.",
        author: "Davide",
        detail: "Sposo · Matrimonio sul Lago Maggiore",
      },
      {
        quote:
          "Avevamo un fotografo bravissimo, ma le foto degli ospiti hanno catturato momenti che lui non poteva essere ovunque a prendere.",
        author: "Federica & Simone",
        detail: "Sposi · Matrimonio in Puglia",
      },
    ],
  },
  faq: {
    eyebrow: "Domande frequenti",
    title: "Tutto quello che vuoi sapere.",
    items: [
      {
        q: "Gli invitati devono scaricare un'app?",
        a: "No. WEDFLOW funziona direttamente dal browser dello smartphone. Basta inquadrare il QR code, scattare o caricare una foto, ed è fatta.",
      },
      {
        q: "Quando riceviamo la galleria?",
        a: "La galleria curata è pronta entro 24 ore dalla fine del matrimonio. I contenuti sono comunque visibili in tempo reale durante l'evento.",
      },
      {
        q: "Le foto sono private?",
        a: "Assolutamente sì. La galleria è protetta e accessibile solo a chi scegli tu. Niente social, niente terze parti.",
      },
      {
        q: "Posso scaricare i file in alta qualità?",
        a: "Sì. A partire dal piano Smart, tutti i contenuti sono disponibili in risoluzione originale, pronti per essere stampati o archiviati.",
      },
      {
        q: "C'è un limite di invitati?",
        a: "No. Ogni invitato può contribuire senza limiti di numero. I limiti eventuali riguardano solo foto/video totali del piano scelto.",
      },
      {
        q: "Posso provare WEDFLOW prima di pagare?",
        a: "Certo. Il piano Free ti permette di testare tutta l'esperienza. Quando sei pronto, passi a Smart o Premium.",
      },
    ],
  },
  waitlist: {
    eyebrow: "Inizia oggi",
    title: "Il tuo matrimonio merita di essere ricordato.",
    sub: "Crea il tuo spazio in pochi minuti. Nessuna app, nessuna complicazione. Solo ricordi.",
    placeholder: "La tua email",
    cta: "Richiedi l'invito",
    loading: "Invio in corso…",
    success: "Ci siamo. Ti scriveremo presto.",
    already: "Sei già nella lista. A presto.",
    error: "Qualcosa è andato storto. Riprova.",
    invalid: "Inserisci un'email valida.",
    privacy: "Nessuno spam. Solo aggiornamenti essenziali.",
  },
  footer: {
    tagline: "Il tuo matrimonio, ricordato per sempre.",
    rights: "Tutti i diritti riservati.",
    made: "Fatto con cura in Italia.",
  },
};

export default it;
